/**
 * Invisible timer component that records wrap-up seconds to Redux on unmount.
 *
 * @module components/sim/WrapUpTimer
 * @author Snowfly
 * @version 1.0.0
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Moment from 'moment';
import { saveWrapSeconds } from '../../redux/sims/actions';

/**
 * A React functional component that tracks the duration of its lifecycle and passes the elapsed time in seconds to a provided callback upon unmounting.
 *
 * @param {Object} props - The input properties for the component.
 * @param {function} props.saveWrapSeconds - A callback function that takes the elapsed time in seconds as a parameter and is invoked when the component unmounts.
 */
const WrapUpTimer = ({ saveWrapSeconds }) => {
    useEffect(() => {
        const startTime = new Moment();
        return () => {
            const endTime = new Moment();
            const duration = Moment.duration(endTime.diff(startTime));
            saveWrapSeconds(duration.asSeconds());
        };
    }, [saveWrapSeconds]);
    return (
        <div>
            {}
        </div>
    );
};

/**
 * Defines the type and requirements for the properties of the WrapUpTimer component.
 * This property validation ensures that the component receives props of the expected type.
 */
WrapUpTimer.propTypes = {
    saveWrapSeconds: PropTypes.func,
};

/**
 * An object used to map action creators to props in a React-Redux container.
 * This allows dispatching of specific Redux actions from the connected component.
 *
 * @property {function} saveWrapSeconds - Action creator function used to dispatch
 * actions related to saving wrap seconds.
 */
const mapDispatchToProps = {
    saveWrapSeconds,
};

export default connect(null, mapDispatchToProps)(WrapUpTimer);
